import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import styles from "./ExamAutoSubmitModal.module.css";

const ExamAutoSubmitModal = ({ isOpen, title, message, confirmText, onConfirm }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const content = (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <button type="button" className={styles.primaryButton} onClick={onConfirm}>
            {confirmText || t("common.close")}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default ExamAutoSubmitModal;
